import { API_ENDPOINTS } from 'src/setup/client/api-endpoints';
import HttpClient from 'src/setup/client/http-client';

// API calls for fetching server data
export function getUserBaseInfo() {
    return HttpClient.get(API_ENDPOINTS.USER_BASE_INFO);
}

export function getUserLevelInfo() {
    return HttpClient.get(API_ENDPOINTS.GET_USER_LEVEL_INFO);
}

export function createFavorite(payload: object) {
    return HttpClient.post(API_ENDPOINTS.CREATE_FAVORITE, payload);
}

export function cancelFavorite(payload: object) {
    return HttpClient.post(API_ENDPOINTS.CANCEL_FAVORITE, payload);
}

export function logout() {
    return HttpClient.get(API_ENDPOINTS.LOGOUT);
}
export function getUserAssets(body: object) {
    return HttpClient.post(API_ENDPOINTS.USER_ASSETS_INFO, body);
}

export function refreshAuthToken() {
    return HttpClient.get(API_ENDPOINTS.REFRESH_AUTH_TOKEN);
}

export function getUserVerifyInfo() {
    return HttpClient.get(API_ENDPOINTS.GET_USER_VERIFY_INFO);
}

export function getUserInviteCode() {
    return HttpClient.get(API_ENDPOINTS.GET_USER_INVITE_CODE);
}
export function openFutures() {
    return HttpClient.get(API_ENDPOINTS.OPEN_FUTURES);
}
